module.exports = __webpack_public_path__ + "static/media/1.2f02c04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/1.png
// module id = 1648
// module chunks = 0